export const ADMIN_PLACEHOLDER_BUSINESS_IDS = new Set([
  'admin_user',
  'admin-temp-user',
  'admin-temp-business'
]);

export function shouldLoadLocalBusinessData(id) {
  return Boolean(id && typeof id === 'string' && !ADMIN_PLACEHOLDER_BUSINESS_IDS.has(id));
}
